import React from 'react';

export default function StudentProfileContent({ studentData }) {
  // Kalan bakiye renk belirleme
  const getBalanceColor = () => {
    const balance = studentData?.kalan_bakiye || 0;
    if (balance > 0) return 'text-red-600';
    if (balance < 0) return 'text-green-600';
    return 'text-blue-600';
  };

  const getBalanceLabel = () => {
    const balance = studentData?.kalan_bakiye || 0;
    if (balance > 0) return 'Borç Bakiyesi';
    if (balance < 0) return 'Alacak Bakiyesi';
    return 'Bakiye Durumu';
  };

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-8">Profilim</h1>
      
      <div className="bg-white rounded-lg shadow p-6">
        {/* Kalan Bakiye Bilgisi */}
        <div className="mb-6 p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold text-gray-700 mb-2">{getBalanceLabel()}</h2>
              <p className={`text-3xl font-bold ${getBalanceColor()}`}>
                {studentData?.kalan_bakiye !== undefined && studentData?.kalan_bakiye !== null ? (
                  <>
                    {studentData.kalan_bakiye > 0 && '+'}
                    {studentData.kalan_bakiye.toFixed(2)} ₺
                  </>
                ) : (
                  '0.00 ₺'
                )}
              </p>
              <p className="text-sm text-gray-500 mt-1">
                {studentData?.kalan_bakiye > 0 && 'Ödemeniz gereken tutar'}
                {studentData?.kalan_bakiye < 0 && 'Size ödenmesi gereken tutar'}
                {(!studentData?.kalan_bakiye || studentData?.kalan_bakiye === 0) && 'Bakiyeniz temiz'}
              </p>
            </div>
            <div className={`p-4 rounded-full ${studentData?.kalan_bakiye > 0 ? 'bg-red-100' : studentData?.kalan_bakiye < 0 ? 'bg-green-100' : 'bg-blue-100'}`}>
              <span className="text-4xl">
                {studentData?.kalan_bakiye > 0 ? '💸' : studentData?.kalan_bakiye < 0 ? '💰' : '✅'}
              </span>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Kişisel Bilgiler</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InfoField label="Ad Soyad" value={studentData?.name} />
            <InfoField label="E-posta" value={studentData?.email} />
            <InfoField label="Veli Adı" value={studentData?.parent_name || '-'} />
            <InfoField label="Kayıt Tarihi" value={studentData?.registration_date || '-'} />
          </div>
        </div>
        
        <hr className="my-6" />
        
        <div>
          <h2 className="text-xl font-semibold mb-4">Ek Bilgiler</h2>
          
          <div className="space-y-4">
            <InfoField label="Veli Telefon" value={studentData?.parent_phone || '-'} />
            <InfoField label="Şehir" value={studentData?.city || '-'} />
            <InfoField label="Sınıf" value={studentData?.sinif || '-'} />
            <InfoField label="Okul" value={studentData?.okul || '-'} />
          </div>
        </div>
      </div>
    </div>
  );
}

// Info Field Component
function InfoField({ label, value }) {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <p className="p-2 bg-gray-100 rounded">{value}</p>
    </div>
  );
}